export const INLINE_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  flex: 1
};

export const START_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  maxWidth: "100%",
  gap: 8
};

export const SPACE_BETWEEN_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  maxWidth: "100%"
};

export const SINGLE_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  flex: 1,
  maxWidth: "100%"
};

export const COLUMN_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  maxWidth: "100%"
};

export const END_BUTTONS_STYLE: React.CSSProperties = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  maxWidth: "100%",
  gap: 8
};
